'use client'

import { Paper, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'
import React from 'react'

const NoteSection = ({ }) => {
    const t = useTranslations('srpFlightDetails');
    return (
        <Paper
            sx={{
                p: 1.5,
                mt: 2,
                backgroundColor: '#F9FAFB',
                boxShadow: 'none'
            }}
        >
            <Typography variant="caption" color="text.secondary" textAlign="start" display="block">
                {t('fareRulesNote')}
            </Typography>
        </Paper>
    )
}

export default NoteSection